import styled from "styled-components";
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { useDispatch } from 'react-redux'
import { useState,useEffect} from "react";
import api from '../../../axios.js'

const Container=styled.div`

`

export default function SelectConsola(props){
  const dispatch = useDispatch();
  const { value = [], action, estado } = props;
  const [consolas, setConsolas] = useState([]);

  useEffect(() => {
    if (estado === 0) {
      const reloadConsolas = async () => {
        try {
          const rpta = await api('/consola');
          const data = rpta.data;
          setConsolas(data);
        } catch (error) {
          console.error("Error cargando consolas", error);
        }
      };
      reloadConsolas();
    }
  }, [estado]);

  const handleChange = (event) => {
    const checked = event.target.checked;
    const id = Number(event.target.id);

    let updated = [...value];
    if (checked) {
      if (!updated.includes(id)) updated.push(id);
    } else {
      updated = updated.filter(ele => ele !== id);
    }

    dispatch(action({ Consolas: updated }));
  };


	return(
		<Container>			
      			{consolas&&value?
      				consolas.map(consola=><FormControlLabel key={consola.id} control={<Checkbox id={consola.id.toString()} name={consola.descripcion} checked={value.includes(Number(consola.id))} onChange={handleChange}/>} label={consola.descripcion}  disabled={estado==0?true:false} />):null}
      			
    	</Container>

		)
}